import { render, staticRenderFns } from "./LoginFeaturesList.vue?vue&type=template&id=1b327736"
import script from "./LoginFeaturesList.vue?vue&type=script&lang=js"
export * from "./LoginFeaturesList.vue?vue&type=script&lang=js"
import style0 from "./LoginFeaturesList.vue?vue&type=style&index=0&id=1b327736&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports